import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import SidebarNav from './SidebarNav';

function CapsuleLogo() {
  return (
    <div className="capsule-icon">
      <div className="left"></div>
      <div className="right"></div>
    </div>
  );
}

export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  function handleLogout() { logout(); navigate('/login'); }
  function closeMobile() { setMobileOpen(false); }

  var userInitial = user?.username?.charAt(0).toUpperCase() || 'U';
  var shopName = user?.shop_name || 'My Pharmacy';
  var username = user?.username || 'User';
  var plan = user?.plan || 'free_trial';

  var planBadge = null;
  if (plan === 'free_trial') planBadge = <span className="plan-badge trial">Trial</span>;
  if (plan === 'pro') planBadge = <span className="plan-badge pro">Pro</span>;
  if (plan === 'pro_plus') planBadge = <span className="plan-badge pro-plus">Pro+</span>;

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-navy-900 text-white flex items-center justify-between px-4 h-14">
        <Button variant="ghost" size="icon" onClick={function() { setMobileOpen(true); }} className="text-white hover:bg-navy-800" data-testid="mobile-menu-btn"><Menu className="w-6 h-6" /></Button>
        <h1 className="font-heading font-bold text-base"><span className="text-mint-400">Pharma</span>Buddy</h1>
        <div className="w-8 h-8 bg-mint-600 rounded-full flex items-center justify-center text-sm font-bold">{userInitial}</div>
      </div>

      {mobileOpen && <div className="lg:hidden fixed inset-0 bg-black/50 z-50" onClick={closeMobile} />}

      <aside className={'w-64 bg-navy-900 text-white flex flex-col fixed h-full z-50 transition-transform duration-200 lg:translate-x-0 ' + (mobileOpen ? 'translate-x-0' : '-translate-x-full')}>
        <div className="p-4 border-b border-navy-700">
          <div className="flex items-center gap-3">
            <CapsuleLogo />
            <div className="flex-1 min-w-0">
              <h1 className="font-heading font-bold text-lg leading-tight"><span className="text-mint-400">Pharma</span><span className="text-white">Buddy</span></h1>
              <div className="flex items-center gap-2"><p className="text-xs text-navy-400 truncate max-w-[100px]">{shopName}</p>{planBadge}</div>
            </div>
            <Button variant="ghost" size="icon" onClick={closeMobile} className="lg:hidden text-navy-400 hover:text-white" data-testid="close-sidebar-btn"><X className="w-5 h-5" /></Button>
          </div>
        </div>

        <SidebarNav onNavigate={closeMobile} />

        <div className="p-3 mx-3 mb-3 bg-navy-800 rounded-lg"><div className="flex items-center gap-2 text-xs"><span className="w-2 h-2 rounded-full bg-slate-400" /><span className="text-navy-400">HIMS: Ready to Connect</span></div></div>

        <div className="p-4 border-t border-navy-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2"><div className="w-8 h-8 bg-mint-600 rounded-full flex items-center justify-center text-sm font-bold">{userInitial}</div><span className="text-sm truncate max-w-[100px]">{username}</span></div>
            <Button variant="ghost" size="icon" onClick={handleLogout} className="text-navy-400 hover:text-white hover:bg-navy-800" data-testid="logout-btn"><LogOut className="w-5 h-5" /></Button>
          </div>
        </div>
      </aside>

      <main className="lg:ml-64 min-h-screen pt-14 lg:pt-0">{children}</main>
    </div>
  );
}
